module.exports = __webpack_public_path__ + "static/media/cuentapublica.04a92048.jpg";